import type { FC } from 'react';
import { useState } from 'react';
import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Table,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import TableCellHeaderSum from '../../../components/global/TableCellHeaderSum';

const SeguimientoTerritorioDetailRow: FC<{ item: any }> = ({ item }) => {
  const [open, setOpen] = useState(item?.open || false);
  const keyDetail = `detail-fuvex-h-${item.label}`;

  return (
    <>
      <TableRow>
        <TableCellHeaderSum>
          {item.detail && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
          {item.label}
        </TableCellHeaderSum>
        <TableCellHeaderSum width={100} align="right">
          {item.value}
        </TableCellHeaderSum>
      </TableRow>
      <TableRow key={keyDetail}>
        <TableCell colSpan={2} style={{ padding: '0px' }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table size="small">
              {item.detail.map((itemDetail) => (
                <>
                  <TableRow>
                    <TableCell style={{ paddingLeft: '50px' }}>
                      {itemDetail.label}
                    </TableCell>
                    <TableCell width={100} align="right">
                      {itemDetail.value}
                    </TableCell>
                  </TableRow>
                </>
              ))}
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default SeguimientoTerritorioDetailRow;
